import { render, staticRenderFns } from "./ProductDetailTemplate.vue?vue&type=template&id=1fc2e076&scoped=true&"
import script from "./ProductDetailTemplate.vue?vue&type=script&lang=js&"
export * from "./ProductDetailTemplate.vue?vue&type=script&lang=js&"
import style0 from "./ProductDetailTemplate.vue?vue&type=style&index=0&id=1fc2e076&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fc2e076",
  null
  
)

export default component.exports